import './index.scss'

interface Props {
    label: string
    action: () => void
    icon: TChildren
}

const PageActionButton = ({ label, action, icon }: Props) => {
    return (
        <div
            className="tab-action-button"
            onClick={action}
            data-testid={`${label}-button`}
        >
            <span>{label}</span>
            <i className="icon">{icon}</i>
        </div>
    )
}

export default PageActionButton
